module.exports = __webpack_public_path__ + "692e5668b9be8cc2aaac378e1edca064.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/6.jpg
// module id = 1365
// module chunks = 47